<div
  class="wrapper"
  (mouseenter)="isMenuOpen = true"
  (mouseleave)="isMenuOpen = false"
>
  <div class="hover-zone" *ngIf="isMenuOpen"></div>

  <button
    #btnTrigger
    mat-button
    tourAnchor="nova-cotacao-btn"
    class="wrapper-trigger"
    [ngClass]="{
      'tour-pulse': tourStepsService.currentAnchor() === 'nova-cotacao-btn'
    }"
    *showIfAuthorized="'BOTAO_NOVA_COTACAO'"
  >
    <span class="wrapper-trigger__content">
      Nova Cotação
      <ng-icon name="heroChevronDown"></ng-icon>
    </span>
  </button>

  <div #menu class="wrapper-menu" *ngIf="isMenuOpen">
    <ul class="wrapper-menu__list">
      <ng-container *ngFor="let item of menusCotacao">
        <li
          *showIfAuthorized="item.showIfAuthorizedName"
          class="wrapper-menu__item"
        >
          <span class="wrapper-menu__title">{{ item.titulo }}</span>
          <ul class="wrapper-menu__submenu">
            <ng-container *ngFor="let subItem of item.list">
              <a
                [routerLink]="subItem.url"
                class="wrapper-menu__submenu-item"
                (click)="openPage(subItem)"
                *showIfAuthorized="subItem.showIfAuthorizedName"
                gaEvent="ID_HEAD_NOVA_COTACAO"
              >
                <ng-icon [name]="subItem.icone"></ng-icon>
                <span>{{ subItem.txt }}</span>
              </a>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
